import React from 'react';
import { Col, Form } from 'react-bootstrap';
import PagesHeader from '../../../../components/base/PagesHeader';

import { CompanyClientSaveMode, FormProps } from '../types';
import classNames from 'classnames';
import { errorHighlighter } from '../../../../util/form';
import ErrorFeedback from '../../../../components/ErrorFeedback';
import PersonalNumber from '../../../../components/form/inputs/PersonalNumber';
import useLocale from '../../../../hooks/useLocale';
import HorizontalRule from '../../../../components/base/HorizontalRule';
import BaseInputText from '../../../../components/base/BaseInputText';
import BaseSelectBox from '../../../../components/base/BaseSelectBox';
import { createFirstNameOptions } from '../../../../util/personalNameUtils';

export default function AuthorizedSignatory({ context }: FormProps) {
  const { /* isEditMode, */ formGroup, combinations, companyDetails, replaceCombinations, authorizedSignatoryOptions } =
    context;
  const { localize } = useLocale();

  const handleCombination = (e, combinationIndex, signatoryIndex) => {
    const _combinations = [...combinations];
    const foundDetails = _combinations[combinationIndex].authorizedSignatory[signatoryIndex];
    if (foundDetails) {
      foundDetails![e.target.name] = e.target.value;
      replaceCombinations(_combinations);
    }
  };
  const handleSignee = (e, combinationIndex) => {
    const _combinations = [...combinations];
    const foundDetails = _combinations[combinationIndex];
    const notFoundDetails = _combinations.filter((i, index) => index !== combinationIndex);
    if (foundDetails) {
      foundDetails['signee'] = e.target.checked;
      replaceCombinations(_combinations);
    }
    if (notFoundDetails) {
      notFoundDetails.map((value) => {
        return (value.signee = false);
      });
      replaceCombinations(_combinations);
    }
  };

  const getFirstNameOptions = (combinationIdx: number, signatoryIdx: number) => {
    const signatory = authorizedSignatoryOptions?.[combinationIdx]?.[signatoryIdx] || null;

    if (!signatory) {
      return [];
    }

    return createFirstNameOptions(signatory.firstNames);
  };

  const handleSelectSignatory = (value, combinationIdx: number, signatoryIdx: number) => {
    const _combinations = [...combinations];
    const foundDetails = _combinations[combinationIdx].authorizedSignatory[signatoryIdx];

    if (foundDetails) {
      foundDetails.firstName = value;

      replaceCombinations(_combinations);
    }
  };

  return (
    <div>
      <PagesHeader pageTitle="Administrative signatory" headingClass="fs-h3" />
      <div className="form-section mb-3 dark-content-section">
        {combinations?.map((item, idx) => {
          return (
            <React.Fragment key={idx}>
              <div className="align-items-end mb-3 flex-wrap-row">
                <div className="d-flex justify-content-between my-2">
                  <div className="theme-text">
                    {localize('signatory_combination')} {idx + 1}
                  </div>
                  <div>
                    <Col style={{ maxWidth: 170 }}>
                      <div className="radio-button-label">
                        <Form.Check
                          inline
                          type="radio"
                          name="signee"
                          id="signee"
                          label={''}
                          style={{ marginRight: 0 }}
                          onChange={(e) => handleSignee(e, idx)}
                          value={item.signee as any}
                          //  checked={form.incharge}
                          disabled={companyDetails.status === CompanyClientSaveMode.SETUP}
                          defaultChecked={item.signee}
                        />
                        <Form.Label className="fs-name mb-0">{localize('signatory_combination')}</Form.Label>
                      </div>
                    </Col>
                  </div>
                </div>
                {item?.authorizedSignatory.map((form, index) => {
                  const firstNameOptions = getFirstNameOptions(idx, index);

                  return (
                    <React.Fragment key={`signatory-${index}`}>
                      <div className="cr-form-row" key={index}>
                        <PersonalNumber
                          disabled={true}
                          value={form.personalNumber}
                          isRequiredError={true}
                          field={formGroup.getFieldMeta(
                            `combinations[${idx}].authorizedSignatory[${index}].personalNumber`,
                          )}
                        />
                        <div className="first-name-field">
                          <Form.Label className="fs-name mb-0">{localize('first_name')}</Form.Label>
                          {/* <Form.Control
                            size="lg"
                            type="text"
                            name="firstName"
                            value={form.firstName}
                            disabled
                            className={classNames('text-left')}
                          /> */}
                          <BaseSelectBox
                            options={firstNameOptions}
                            value={form.firstName}
                            onChangeHandler={(e) => handleSelectSignatory(e.target.value, idx, index)}
                          />
                        </div>
                        <div className="last-name-field">
                          <Form.Label className="fs-name mb-0 ">{localize('last_name')}</Form.Label>
                          <Form.Control
                            size="lg"
                            type="text"
                            name="lastName"
                            value={form.lastName}
                            disabled
                            className={classNames('text-left')}
                          />
                        </div>
                        <BaseInputText
                          containerClassName="role-field"
                          inputClassName="role-input text-left"
                          label={localize('role')}
                          trimmed
                          value={form.position || ''}
                          disabled
                        />
                        <div className="email-field">
                          <Form.Group>
                            <Form.Label
                              className={classNames('fs-name mb-0', {
                                required: formGroup.values.combinations[idx].signee,
                              })}
                            >{`${localize('email_address')}`}</Form.Label>
                            <Form.Control
                              size="lg"
                              type="text"
                              onChange={(e) => handleCombination(e, idx, index)}
                              name="email"
                              value={form.email}
                              className={classNames(
                                'text-left',
                                errorHighlighter(
                                  formGroup.getFieldMeta(`combinations[${idx}].authorizedSignatory[${index}].email`),
                                ),
                              )}
                              disabled={companyDetails.status === CompanyClientSaveMode.SETUP}
                            />
                            <ErrorFeedback
                              field={formGroup.getFieldMeta(`combinations[${idx}].authorizedSignatory[${index}].email`)}
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>
              {combinations.length + 1 !== idx && <HorizontalRule color="#232D37" height="1px" />}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
